// ** Redux Imports
import { combineReducers } from 'redux'

// ** Reducers Imports
import auth from './auth'
import navbar from './navbar'
import layout from './layout'
import users from '@src/views/apps/user/store/reducer'
import bulletins from '@src/views/apps/bulletin/store/reducer'
import monthlyFinancial from '@src/views/apps/monthlyFinancial/store/reducer'
import logs from '@src/views/apps/log/store/reducer'
import permissions from '@src/views/apps/permission/store/reducer'

import memberDirectory from '@src/views/apps/memberDirectory/store/reducer'

const rootReducer = combineReducers({
  auth,
  users,
  bulletins,
  monthlyFinancial,
  navbar,
  layout,
  logs,
  permissions,
  memberDirectory
})

export default rootReducer
